// import PostList from "@/components/PostList";
// import { IBlogPosts } from "./IBlog";

// export async function getStaticProps() {
//   const data = await fetch(
//     "https://cms.robonito.com/api/blogs?populate=*&sort[0]=createdAt:DESC&pagination[page]=1&pagination[pageSize]=1000",   { cache: 'force-cache' }
//   ).then((res) => res.json());

//   return { props: { blog: data } };
// }

// export async function getStaticPaths() {
//   const data = await fetch(
//     "https://cms.robonito.com/api/blogs?pagination[page]=1&pagination[pageSize]=1000",{cache: "no-store"}
//   ).then((res) => res.json());
//   let paths = [];

//   for (let index = 0; index < data.meta.pagination.total / 10; index++) {

//     paths.push({ params: { pageId: (index + 1).toString() } });
//   }

//   return { paths, fallback: false };
// }

// export default function Blog({ blog }: { blog: IBlogPosts }) {
//   return (
//     <div className="bg-gray-50">
//       <div className="mx-auto mt-0 mb-8 max-w-7xl py-10 px-6 lg:px-8 ">
//       <div className="flex items-end justify-between">
//             <div className="flex-1 text-center lg:text-left">
//                 <h2 className="text-xl font-bold leading-tight text-black sm:text-2xl lg:text-4xl">Latest from blog</h2>
//                 <p className="max-w-3xl mx-auto mt-3 text-base leading-relaxed text-gray-600 lg:mx-0">Explore insightful articles, updates, and stories on our engaging and informative blog platform.</p>
//             </div>
//         </div>
//         <div className="grid max-w-md grid-cols-1 gap-6 mx-auto mt-5 lg:mt-16 lg:grid-cols-3 lg:max-w-full">
//           {blog?.data?.map((post) => (
//             <PostList key={post.id} post={post} />
//           ))}
//         </div>
//       </div>
//       <div className="container mx-auto px-4">
//   <nav className="flex flex-row flex-nowrap justify-between md:justify-center items-center" aria-label="Pagination">
//     <a className="flex w-10 h-10 mr-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300" href="#" title="Previous Page">
//         <span className="sr-only">Previous Page</span>
//         <svg className="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
//             <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
//         </svg>
//     </a>
//     <a className="hidden md:flex w-10 h-10 mx-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300" href="#" title="Page 1">
//         1
//     </a>

//     <a className="hidden md:flex w-10 h-10 mx-1 justify-center items-center rounded-full border border-black bg-black text-white pointer-events-none" href="#" aria-current="page" title="Page 3">
//         3
//     </a>

//     <a className="flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300" href="#" title="Next Page">
//         <span className="sr-only">Next Page</span>
//         <svg className="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
//             <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path>
//         </svg>
//     </a>
//   </nav>
// </div>
//     </div>
//   );
// }
import PostList from "@/components/PostList";
import { IBlogPosts } from "./IBlog";
import Head from "next/head";

export async function getStaticProps({ params }: { params: any }) {
  const page = params?.pageId || 1;

  const data = await fetch(
    `https://cms.robonito.com/api/blogs?populate=*&sort[0]=createdAt:DESC&pagination[page]=${page}&pagination[pageSize]=21`, { cache: 'force-cache' }
  ).then((res) => res.json());

  return { props: { blog: data } };
}

export async function getStaticPaths({ params }: { params: any }) {
  // const page = params?.pageId || 1;
  const data = await fetch(
    `https://cms.robonito.com/api/blogs`, { cache: "no-store" }
  ).then((res) => res.json());

  const totalPages = Math.ceil(data.meta.pagination.total / 20);
  let paths = [];

  for (let index = 1; index <= totalPages; index++) {
    paths.push({ params: { pageId: index.toString() } });
  }

  return { paths, fallback: false };
}

export default function Blog({ blog }: { blog: IBlogPosts }) {
  // console.log(blog);

  return (
    <>
      {/* <Head>
        <link rel="alternate" type="application/rss+xml" title="RSS Feed" href="/api/rss" />
      </Head> */}
      <div className="bg-gray-50">
        <div className="mx-auto mt-0 mb-8 max-w-7xl py-10 px-6 lg:px-8 ">
          <div className="flex items-end justify-between">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl font-bold leading-tight text-black sm:text-2xl lg:text-4xl">Latest from blog</h2>
              <p className="max-w-3xl mx-auto mt-3 text-base leading-relaxed text-gray-600 lg:mx-0">Explore insightful articles, updates, and stories on our engaging and informative blog platform.</p>
            </div>
          </div>
          <div className="grid max-w-md grid-cols-1 gap-6 mx-auto mt-5 lg:mt-16 lg:grid-cols-3 lg:max-w-full">
            {blog?.data?.map((post) => (
              <PostList key={post.id} post={post} />
            ))}
          </div>
          <div className="container mx-auto px-4 pt-5">
            <nav className="flex flex-row flex-wrap justify-between md:justify-center items-center" aria-label="Pagination">
              <a href={`/blog/1`} className="flex w-10 h-10 mr-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300">
                <span className="sr-only">Previous Page</span>
                <svg className="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
                  <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
                </svg>
              </a>
              {Array.from({ length: Math.ceil(Number(blog.meta.pagination.total / 20)) }, (_, index) => (
                <a key={index + 1} href={`/blog/${index + 1}`} className={`flex w-10 h-10 mx-1 justify-center items-center rounded-full border ${index + 1 === blog.meta.pagination.page ? 'border-black bg-black text-white' : 'border-gray-200 bg-white'} hover:border-gray-300`}>
                  {index + 1}
                </a>
              ))}
              <a href={`/blog/${blog.meta.pagination.pageCount}`} className="flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300">
                <span className="sr-only">Next Page</span>
                <svg className="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
                  <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path>
                </svg>
              </a>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
